import type { APIMethodParams } from '@medizzy/api';
import { z } from 'zod';

export const createCheckoutSessionRequestSchema = z.object({
  period: z.enum(['monthly', 'yearly']).optional(),
  variant: z.enum(['default', 'discount', 'reddit']).optional(),
  return: z.enum(['landing', 'profile']).optional(),
});

export const createCheckoutSessionResponseSchema = z.object({
  url: z.string(),
});

export function createCheckoutSession({
  client,
  params,
}: APIMethodParams<z.infer<typeof createCheckoutSessionRequestSchema>>) {
  return client
    .url('/v2/payments/stripe/checkout/sessions')
    .query(params)
    .post()
    .valid(createCheckoutSessionResponseSchema);
}
